import { parseISO, format } from 'date-fns';

export const dateIso2Us = (isoIn) => {
    if (isoIn) return format(parseISO(isoIn), 'P');
    return null;
}

export const currentDatetimeIso = () => {
    return format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS");
}